import { useDispatch } from 'store/hooks';
import { supportRequestAction } from './actions';

export const useDispatchSupportRequestAction = () => {
    const dispatch = useDispatch();
    return (
        enquiry: string,
        name?: string,
        screenshot?: string,
        forDevTeam?: boolean
    ) => {
        dispatch(supportRequestAction(enquiry, name, screenshot, forDevTeam));
    };
};
